import { getFileName } from '@zealot/ui/lib/chatMessageUtils';
import { cn } from '@zealot/ui/lib/utils';
import { Download, FileText } from 'lucide-react';
import type * as React from 'react';

type PdfDownloadCardProps = Omit<React.ComponentProps<'a'>, 'href' | 'children'> & {
  url: string;
};

const PdfDownloadCard = ({ url, className, onClick, ...props }: PdfDownloadCardProps) => {
  return (
    <a
      data-slot="pdf-download-card"
      href={url}
      download
      target="_blank"
      rel="noopener noreferrer"
      onClick={(event) => {
        event.stopPropagation();
        onClick?.(event);
      }}
      className={cn(
        'flex items-center gap-3 rounded-lg border border-border bg-card px-3 py-2.5 text-sm transition-colors hover:bg-muted',
        className,
      )}
      {...props}
    >
      <FileText className="size-4 shrink-0 text-muted-foreground" />
      <span className="font-medium text-muted-foreground">PDF</span>
      <span className="min-w-0 flex-1 truncate font-medium text-foreground">{getFileName(url)}</span>
      <span className="flex shrink-0 items-center gap-1 text-muted-foreground">
        <Download className="size-3.5" />
        Download
      </span>
    </a>
  );
};

export type { PdfDownloadCardProps };
export { PdfDownloadCard };
